<template>
  <div>
    <div class="w-1/2">
      <div>
        <v-progress-linear
          v-if="progressbar"
          :indeterminate="indeterminate"
          color="blue"
        ></v-progress-linear>
      </div>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">
            Begin to upload CSV
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2">
            Get CSV file (must be csv.csv)
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            Click upload
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-btn class="w-full" @click="clearTableCsv('csv')">
              Click to start the process of CSV Upload
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <div class="text-xl font-bold">
              CHOOSE CSV FILE <br /><span class="text-xs">
                Must be csv.csv | Include the header row title
              </span>
            </div>

            <div>
              <input type="file" @change="onFileChange" />
            </div>
          </v-stepper-content>

          <v-stepper-content step="3">
            <button
              :class="
                !this.selectedFile
                  ? 'hidden'
                  : 'w-full border border-solid border-blue-900 rounded p-1 my-2 hover:bg-gray-400 hover:text-gray-600'
              "
              @click="onUploadFile"
              :disabled="!this.selectedFile"
            >
              Click to Upload Now!
            </button>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <!-- datatable  -->
    <div class="my-4 w-full">
      <!-- <v-btn :loading="syncloading" small @click="synchronizeContracts"
        >Synchronize contracts</v-btn
      > -->
      <div>
        <div class="text-2xl font-bold text-left mt-10 mb-4">
          CSV DATABASE <br /><span class="text-sm"
            >TOTAL: {{ totalCount }}</span
          >
        </div>

        <div class="">
          <v-card class="w-1/2" elevation="0">
            <v-card-text>
              <div class="overflow-x-auto">
                <div class="flex items-center space-x-4">
                  <v-text-field
                    label="Type the contract number"
                    v-model="contract_number_search"
                  ></v-text-field>
                  <div class="space-x-2">
                    <v-btn @click="onClickSearch" :loading="btnLoading">
                      Search Contract Number
                    </v-btn>
                    <v-btn @click="clearSearch">Clear Search</v-btn>
                  </div>
                </div>
              </div>
              <v-data-table
                class="elevation-1 datatable "
                :headers="headers"
                :items="items"
                :loading="loading"
              >
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
    <v-snackbar top v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable  */
import axios from "axios";
export default {
  data() {
    return {
      syncloading: false,
      totalCount: 0,
      btnLoading: false,
      filteredSearch: "",
      snackbar: false,
      snackbarText: "",
      contract_number_search: "",
      e1: 1,
      tableCleared: false,
      contractNumbers: [],
      selectedContractNumber: null,
      headers: [
        { text: "Customer Code", value: "customer_code" },
        { text: "Contract Number", value: "contract_number" },
        { text: "Buyer Name", value: "buyer_name" },
        { text: "Street", value: "street" },
        { text: "District", value: "district" }, // Corrected typo from "Distrct"
        { text: "City", value: "city" },
        { text: "Telephone 1", value: "telephone1" },
        { text: "Telephone 2", value: "telephone2" },
        { text: "Email Address", value: "email_address" },
        { text: "Project", value: "project" },
        { text: "Building", value: "building" },
        { text: "Rental Unit", value: "rental_unit" },
        { text: "Phase", value: "phase" },
        { text: "Block", value: "block" },
        { text: "Lot", value: "lot" },
        { text: "Financing", value: "financing" },
        { text: "Company Code", value: "company_code" },
      ],
      items: [],
      loading: false,
      search: "",
      selectedFile: "",
      indeterminate: false,
      progressbar: false,
    };
  },
  async mounted() {
    await this.getAllContracts(); // Fetch the data when the component is mounted
  },

  methods: {
    // async synchronizeContracts() {
    //   this.syncloading = true;
    //   try {
    //     const response = await axios.post("/contracts/syncContracts");
    //     if (response.data.status) {
    //       this.syncloading = false;
    //       alert(response.data.message);
    //     }
    //   } catch (error) {
    //     console.error("Error during synchronization:", error);
    //     alert("Error during synchronization.");
    //   } finally {
    //     this.vbtProgress = false;
    //   }
    // },
    clearSearch() {
      this.contract_number_search = "";
      this.getAllContracts();
    },
    async getAllContracts() {
      try {
        // Fetch the data from Supabase using async/await
        const response = await axios.get("/cs_data/all-contract");

        // Store the fetched data in the `items` array
        this.items = response.data.data;

        // Store the total count
        this.totalCount = response.data.count;
      } catch (error) {
        console.error("Error fetching contract numbers:", error);
      }
    },

    onClickSearch() {
      if (this.contract_number_search === "") {
        this.snackbar = true;
        this.snackbarText = "Please enter a contract number";
      } else {
        this.items = [];
        this.searchContract(this.contract_number_search); // Used correct method and variable
      }
    },
    async searchContract(cn) {
      this.btnLoading = true;
      const data = {
        contract_number: cn,
      };
      const response = await axios.post("/cs_data/contract_number", data);

      if (response.data.status) {
        this.btnLoading = false;
        this.items = response.data.output;
      } else {
        this.btnLoading = false;
        this.snackbar = true;
        this.snackbarText = "No data found";
      }
    },
    async clearTableCsv() {
      this.progressbar = false;
      this.indeterminate = false;
      this.tableCleared = true;
      this.e1 = 2;
    },
    // async getContractNumbers() {
    //   const response = await axios.get("/cs_data/all-contract"); // Corrected URL
    //   this.items = response.data.data;
    // },
    onFileChange(e) {
      this.selectedFile = "";
      const selectedFile = e.target.files[0]; // accessing file

      if (selectedFile.name != "csv.csv") {
        return alert(
          `Wrong filename:${selectedFile.name}. Please use csv.csv!`
        );
      } else {
        this.selectedFile = selectedFile;
        this.e1 = 3;
      }
    },

    async onUploadFile() {
      this.progressbar = true;
      this.indeterminate = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);

      try {
        const response = await axios.post("/csv_upload/upload", formData);

        if (response.data.error) {
          alert("Error uploading file");
        } else {
          alert(response.data.message);
          this.selectedFile = null;
          this.e1 = 1;
          location.reload();
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("Error uploading file");
      } finally {
        this.progressbar = false;
        this.indeterminate = false;
      }
    },
  },
};
</script>

<style scoped>
.datatable {
  white-space: nowrap;
}

.progress-container {
  width: 100%;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 1rem;
  position: relative;
  height: 20px;
}

.progress-bar {
  height: 100%;
  background-color: #4caf50;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  font-weight: bold;
}
</style>
